import { useState } from 'react';

interface QuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function QuoteModal({ isOpen, onClose }: QuoteModalProps) {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });
    
    try {
      await fetch('https://readdy.ai/api/form/d5j484qgbpr25eot4430', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });
      setFormStatus('success');
      e.currentTarget.reset();
      setTimeout(() => {
        setFormStatus('idle');
        onClose();
      }, 2000);
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white max-w-md w-full p-8 relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
        >
          <i className="ri-close-line text-2xl"></i>
        </button>
        
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Запрос коммерческого предложения</h3>
        <p className="text-sm text-gray-500 mb-6">Заполните форму, и мы вышлем КП в течение 1 рабочего дня</p>
        
        <form 
          data-readdy-form
          onSubmit={handleSubmit}
          className="space-y-5"
        >
          <input
            type="text"
            name="company"
            placeholder="Компания"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
          />
          <input
            type="text"
            name="contact"
            placeholder="Контактное лицо"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Телефон"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A]"
          />
          <textarea
            name="requirements"
            placeholder="Требования к оборудованию (грузоподъёмность, высота подъёма и т.д.)"
            maxLength={500}
            rows={4}
            className="w-full px-3 py-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A] resize-none"
          />
          <button 
            type="submit"
            className="w-full bg-[#1A2B4A] text-white h-[52px] text-base font-medium hover:bg-[#0F1A2E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Отправить запрос
          </button>

          {formStatus === 'success' && (
            <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 text-sm">
              Спасибо! Ваш запрос отправлен.
            </div>
          )}
          {formStatus === 'error' && (
            <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 text-sm">
              Произошла ошибка. Попробуйте позже.
            </div>
          )}
        </form>
      </div>
    </div>
  );
}